import { log } from "../../utils";
import { ChatServerAsyncActionType } from "../../utils/useChatServerDispatch";

export default function sendBargeOut(): ChatServerAsyncActionType {
    return chatServer => () => {
        chatServer.bargeOut((err?: Error) => {
            if (err) {
                log(err);
            }
        });
    };
}